import { render, staticRenderFns } from "./Zlzp.vue?vue&type=template&id=c58b3e4a&scoped=true"
import script from "./Zlzp.vue?vue&type=script&lang=js"
export * from "./Zlzp.vue?vue&type=script&lang=js"
import style0 from "./Zlzp.vue?vue&type=style&index=0&id=c58b3e4a&prod&lang=scss&scoped=true"
import style1 from "./Zlzp.vue?vue&type=style&index=1&id=c58b3e4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58b3e4a",
  null
  
)

export default component.exports